import React, { useEffect, useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';

const Contact = ({ data: { title, mapUrl, infoList, formTitle, formFields } }) => {
  const [loadedMapUrl, setLoadedMapUrl] = useState('');
  const [formData, setFormData] = useState({});
  const [state, handleSubmit] = useForm('xgvebnqn');

  useEffect(() => {
    setLoadedMapUrl(mapUrl);
  }, [mapUrl]);

  useEffect(() => {
    if (state.succeeded) {
      setFormData({});
    }
  }, [state.succeeded]);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async e => {
    e.preventDefault();
    await handleSubmit(e);
  };

  return (
    <div className="card-inner active">
      <div className="card-wrap">
        <div className="content contacts">
          <div className="title">{title}</div>
          <div className="content-space noSpace resumeSection">
            <div className="row row-margin">
              <div className="col-md-12 colSpace">
                <div className="map">
                  <iframe
                    src={loadedMapUrl}
                    style={{ border: 0, width: '100%', height: '100%' }}
                    loading="lazy"
                    title="Google Map of New York City"
                  ></iframe>
                </div>
                <div className="info-list">
                  <ul>
                    {infoList.map((item, index) => (
                      <li key={index}>
                        <strong>{item.label} . . . . .</strong> {item.value}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="clear"></div>
            </div>
          </div>
        </div>
        <div className="content contacts">
          <div className="title">{formTitle}</div>
          <div className="content-space PD0">
            <div className="row">
              <div className="col-md-12">
                <div className="contact_form">
                  <form id="cform" onSubmit={onSubmit}>
                    <div className="row">
                      {formFields.map((field, index) => (
                        <div key={index} className={`col-md-${field.colSize}`}>
                          <div className="group-val">
                            {field.type === 'textarea' ? (
                              <textarea
                                name={field.name}
                                placeholder={field.placeholder}
                                required
                                value={formData[field.name] || ''}
                                onChange={handleChange}
                              ></textarea>
                            ) : (
                              <input
                                type={field.type}
                                name={field.name}
                                placeholder={field.placeholder}
                                required
                                value={formData[field.name] || ''}
                                onChange={handleChange}
                              />
                            )}
                            <ValidationError
                              prefix={field.name}
                              field={field.name}
                              errors={state.errors}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    {state.succeeded && (
                      <div className="alert-success">
                        <p>Thanks, your message is sent successfully.</p>
                      </div>
                    )}
                    {state.errors && state.errors.length > 0 && (
                      <div className="alert-error">
                        <p>There was an error sending your message. Please try again.</p>
                      </div>
                    )}
                    <div className="align-left">
                      <button type="submit" className="btn-submit" disabled={state.submitting}>
                        <span className="text">Send Message</span>&nbsp;
                        <span className="arrow">
                          <i className="fa fa-arrow-right" aria-hidden="true"></i>
                        </span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div className="clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
